export  function addCalled(value){
    return dispatch => {
        dispatch({
            type: 'ADD',
            payload: value,
        })
    }
}
